import { render, staticRenderFns } from "./OfficerDetailsPerformance.vue?vue&type=template&id=6beffb9f"
import script from "./OfficerDetailsPerformance.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports